import { AppPageShell, GlobalNotAuthorized } from "@/components/ui";
import LawWorksLoader from "@/components/ui/LawWorksLoader/LawWorksLoader";
import { useUser } from "@/components/UserProvider";
import { getCurrentUserOptions } from "@/lib/data/react-query";
import { PAGE_PERMISSION_KEYS } from "@/lib/data/static/permissionOptions";
import { createFileRoute, Outlet, useLocation } from "@tanstack/react-router";
import { Suspense } from "react";

export const Route = createFileRoute("/_auth/settings")({
  component: RouteComponent,
  loader: ({ context: { queryClient } }) => {
    return {
      currentUser: queryClient.ensureQueryData(getCurrentUserOptions()),
    };
  },
});

function RouteComponent() {
  const { hasAnyPagePermission } = useUser();
  const isTemplatesRoute = useLocation({
    select: (location) => location.pathname === "/settings/templates",
  });

  if (
    !hasAnyPagePermission([
      PAGE_PERMISSION_KEYS.intakeSettings,
      PAGE_PERMISSION_KEYS.contactsSettings,
      PAGE_PERMISSION_KEYS.firmMyFirm,
      PAGE_PERMISSION_KEYS.firmFiles,
      PAGE_PERMISSION_KEYS.firmTemplates,
      PAGE_PERMISSION_KEYS.firmSettings,
      PAGE_PERMISSION_KEYS.mattersSettings,
    ])
  ) {
    return <GlobalNotAuthorized />;
  }

  return (
    <Suspense fallback={<LawWorksLoader className="w-full" />}>
      <AppPageShell
        className={
          isTemplatesRoute ? "h-full max-h-full overflow-hidden" : undefined
        }
      >
        <Outlet />
      </AppPageShell>
    </Suspense>
  );
}
